import React from 'react';
import OutbrainCreativeGroup from './OutbrainCreativeGroup';

class OutbrainCreativeGroupBuilder extends React.Component {
  render() {
    return (
      <>
        {this.props.groups.map((el, groupIdx) => (
          <OutbrainCreativeGroup
            index={groupIdx}
            key={'obCreativeGroup' + groupIdx}
            onAddImage={(groupIdx, e) => this.props.onAddImage(groupIdx, e)}
            onAddImages={(idx, imageBlob, deviceType, index) =>
              this.props.onAddImages(idx, imageBlob, deviceType, index)
            }
            onChangeImageDescription={(imageIdx, e) => this.props.onChangeImageDescription(groupIdx, imageIdx, e)}
            onChangeImageTitle={(imageIdx, e) => this.props.onChangeImageTitle(groupIdx, imageIdx, e)}
            removeImage={imageIdx => this.props.removeImage(groupIdx, imageIdx)}
            duplicateImage={imageIdx => this.props.duplicateImage(groupIdx, imageIdx)}
            removeGroup={() => this.props.removeGroup(groupIdx)}
            duplicateGroup={() => this.props.duplicateGroup(groupIdx)}
            populateText={imageIdx => this.props.populateText(groupIdx, imageIdx)}
            group={this.props.groups[groupIdx]}
          />
        ))}
      </>
    );
  }
}

export default OutbrainCreativeGroupBuilder;
